// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__qmcAT","additionalInfo":"AgreementModal_additionalInfo__3bihq"};